// const baseUrl = 'http://192.168.1.162:1033'
// const baseUrl = 'http://192.168.1.162:1035/'
// const baseUrl = 'https://fczg.zxkjnc.com/'
const baseUrl = 'https://fczg.zxkjnc.com/'
// const baseUrl = process.env.NODE_ENV === 'development' ? 'http://192.168.1.162:1051' : ''

module.exports = {
    baseUrl
}
